import { render, staticRenderFns } from "./ProcessesMenu.vue?vue&type=template&id=e54cc68e&"
import script from "./ProcessesMenu.vue?vue&type=script&lang=js&"
export * from "./ProcessesMenu.vue?vue&type=script&lang=js&"
import style0 from "./ProcessesMenu.vue?vue&type=style&index=0&id=e54cc68e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports